import { render, staticRenderFns } from "./PlantillasTableAssig.vue?vue&type=template&id=19385f9f&lang=pug&"
import script from "./PlantillasTableAssig.vue?vue&type=script&lang=js&"
export * from "./PlantillasTableAssig.vue?vue&type=script&lang=js&"
import style0 from "./PlantillasTableAssig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports